import React from 'react'
import { resolveBuyerLogoUrl } from '@labrav/common'

export const BuyerLogo = ({
  logoUrl,
  classes,
}: {
  logoUrl?: string
  classes: { buyerIcon?: string; customIcon?: string }
}) => {
  const resolvedUrl = resolveBuyerLogoUrl(logoUrl)
  return resolvedUrl ? (
    <img src={resolvedUrl} data-testid="logo" className={classes.buyerIcon} />
  ) : (
    <div className={classes.customIcon} />
  )
}
